import DeudaReportPage from "./DeudaReportPage";

export {DeudaReportPage}
export default DeudaReportPage
